import React from "react";
import { Button, Tooltip } from "antd";
import { DesktopOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ThemeMode, useTheme } from "./ThemeProvider";

const ICONS: Record<ThemeMode, React.ReactNode> = {
  light: <SunOutlined />,
  dark: <MoonOutlined />,
  auto: <DesktopOutlined />,
};

export function ThemeToggle() {
  const { mode, cycleMode } = useTheme();
  const { t } = useTranslation();
  const modeLabel = t(`theme.${mode}`);

  return (
    <Tooltip title={t("theme.tooltip", { mode: modeLabel })} placement="left">
      <Button
        className="Theme-toggle"
        shape="circle"
        size="large"
        icon={ICONS[mode]}
        aria-label={t("theme.ariaLabel", { mode: modeLabel })}
        onClick={cycleMode}
      />
    </Tooltip>
  );
}
